module.exports = __webpack_public_path__ + "static/Sphinx-5d8b5e30bafb1f08cfdc038a84b1cc89.jpg";